import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeadersWithAuthorizationPhoto as prepareHeaders } from '@/apis/headers';

const BASE_URL = 'https://graph.microsoft.com/v1.0';

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL, prepareHeaders }),
  endpoints: (builder) => ({
    getUserPhoto: builder.query<string | null, void>({
      async queryFn(_arg, _api, _extra, fetchWithBQ) {
        const response = await fetchWithBQ({
          url: '/me/photo/$value',
          responseHandler: (r) => r.blob(),
        });

        if (response.error) {
          return { data: null };
        }

        const blob = response.data as Blob;

        const imageUrl = URL.createObjectURL(blob);

        return { data: imageUrl };
      },
    }),
  }),
});

export const { useGetUserPhotoQuery } = userApi;
